/*
 * Copyright (c) 2020
 *    Reliant Business Valuation, LLC - http://www.reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {User} from './user';

export class ReportNote {
  ID: string;

  CONTENT: string;
  CLIENT_VISIBLE: boolean;
  ORDER: number;

  DATE_CREATED: Date;
  DATE_UPDATED: Date;

  CREATOR: User;
  DELAY: boolean;

  constructor(value: any = {}) {
    this.CLIENT_VISIBLE = false;
    this.DELAY = false;
    this.CONTENT = null;

    Object.assign(this, value);

    if(value.CREATOR)
      this.CREATOR = User.parse(value.CREATOR);
  }

  static parseArray(json: any[]): ReportNote[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(new ReportNote(j));

    return arr;
  }
}
